import { HcpSection } from '@/pages/HCPOverview/tabs';
import { AppRoutes } from '@/utils';
import { ComponentType } from 'react';
import ATDataPrivacyDisclaimer from './components/ATDataPrivacyDisclaimer/ATDataPrivacyDisclaimer';
import DEAggregatedConsentDisclaimer from './components/DEAggregatedConsentDisclaimer/DEAggregatedConsentDisclaimer';
import DEDataPrivacyDisclaimer from './components/DEDataPrivacyDisclaimer/DEDataPrivacyDisclaimer';
import DEPersonifyComplianceDisclaimer from './components/DEPersonifyComplianceDisclaimer/DEPersonifyComplianceDisclaimer';
import DEInsightsDisclaimer from './components/DEInsightsDisclaimer/DEInsightsDisclaimer';

export interface DisclaimerRule {
  path: string;
  section?: string;
  components: Record<string, ComponentType>;
}

export const DISCLAIMS_REGISTRY: DisclaimerRule[] = [
  {
    path: AppRoutes.PERSONALIZED_ENGAGEMENT,
    components: { DE: DEPersonifyComplianceDisclaimer },
  },
  {
    path: AppRoutes.HCP_OVERVIEW,
    section: HcpSection.PERSONALIZED_ENGAGEMENT,
    components: { DE: DEPersonifyComplianceDisclaimer },
  },
  {
    path: AppRoutes.CHANNEL_FOCUS_GROUP,
    components: { DE: DEDataPrivacyDisclaimer, AT: ATDataPrivacyDisclaimer },
  },
  {
    path: AppRoutes.GLOBAL_BENCHMARKING_GROUP,
    components: { DE: DEDataPrivacyDisclaimer, AT: ATDataPrivacyDisclaimer },
  },
  {
    path: AppRoutes.AGGREGATED_CONSENT_GROUP,
    components: { DE: DEAggregatedConsentDisclaimer },
  },
  {
    path: AppRoutes.INSIGHTS_GROUP,
    components: { DE: DEInsightsDisclaimer },
  },
];
